<template>
  <app-layout>
    <template #header>
      <h2 class="font-bold text-2xl text-gray-800 leading-tight inline-flex">
        <img src="/images/retro.svg" class="h-8 w-8"/>
        <span class="ml-2"> Retrospective Dashboard</span>
      </h2>
    </template>

    <jet-dialog-modal maxWidth="2xl" :show="createRetroModal === true" @close="createRetroModal = false">
      <template #content>

        <create-retro-form :click-text="'Create Your Board'" @created="boardCreated"></create-retro-form>
      </template>

      <template #footer>
        <div class="text-md text-blue-500 font-bold inline-block ml-1">
          agilesuite.io
        </div>
      </template>
    </jet-dialog-modal>
    <div class="h-full flex">
      <div class="flex flex-col w-0 flex-1">
        <main class="flex-1 relative focus:outline-none px-8">
          <bread-nav :pages="pages"></bread-nav>
          <ActionBoard  type="public" ></ActionBoard>
        </main>
      </div>
    </div>


  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "@/Jetstream/Button";
import {message} from "ant-design-vue";
import {
  ref,
  onMounted,
} from "vue";
import JetDialogModal from "@/Jetstream/DialogModal";
import CreateRetroForm from "@/Pages/Retrospective/CreateRetroForm";
import ActionBoard from "@/Pages/Retrospective/ActionBoard/ActionBoard";
import CustomRetroFlow from "@/Pages/Retrospective/CustomRetroFlow";
import PublicBoardList from "@/Pages/Retrospective/PublicBoardList";
import TeamBoardList from "@/Pages/Retrospective/TeamBoardList";
import TeamMemberManager from "@/Pages/Teams/TeamMemberManager";
import TeamSelectionDropdown from "@/Layouts/TeamSelectionDropdown";
import Show from "@/Pages/Teams/Show";
import Feedback from "@/Components/Feedback";
import RetroMetrics from "@/Pages/Retrospective/RetroMetrics";
import {
  ChartPieIcon,
  EyeIcon,
  LightBulbIcon,
  CogIcon,
  MenuIcon
} from "@heroicons/vue/outline";
import BreadNav from "@/Components/BreadNav/BreadNav";

export default {
  props: ['teamId'],
  data() {
    return {
      pages: [],
      currentIndex: 3,
      showSideBar: true,
      testStyle: '  background: -webkit-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -webkit-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -o-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -o-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -moz-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -moz-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), linear-gradient(110deg, #dd0000 66%, #ffc608 66%);'

    };
  },
  mounted() {
    this.pages = [
      {name: 'Retrospective', href: '#', current: false},
      {name: 'Public Actions', href: '#', current: true},
    ]
  },
  created() {
  },
  setup() {

    const cards = ref([]);
    const createRetroModal = ref(false);

    return {
      createRetroModal,
      cards,
    }
  },

  methods: {
    getColorBackgroundString(color) {
      return 'background: linear-gradient(to right, ' + color.join(',') + ');';
    },
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#board" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/boards/' + id : 'https://agilesuite.io/boards/' + id;
    },
  },
  components: {
    BreadNav,
    ChartPieIcon,
    EyeIcon,
    LightBulbIcon,
    CogIcon,
    MenuIcon,
    RetroMetrics,
    Feedback,
    Show,
    TeamSelectionDropdown,
    TeamMemberManager,
    TeamBoardList,
    PublicBoardList,
    CustomRetroFlow,
    ActionBoard,
    CreateRetroForm,
    JetDialogModal,
    Button,
    AppLayout,
  },
};
</script>
